import { Theme } from "@mui/system";
import { PropsWithChildren, ReactNode } from "react";

import { Box, Typography } from "@tsp/tsp-frontend-components/mui";

interface Props {
  title: ReactNode;
}

const classes = {
  root: (theme: Theme) => ({
    width: "100%",
    maxWidth: 1920,
    display: "flex",
    margin: "0 auto",
    alignItems: "center",
    marginBottom: theme.spacing(3),
    padding: `0 ${theme.spacing(7)}`,
  }),
  title: {
    flex: "0 1 auto",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  aside: {
    flex: "1 0 auto",
    ml: 2,
  },
};

export function Title({ title, children }: PropsWithChildren<Props>) {
  return (
    <Box sx={classes.root}>
      <Typography sx={classes.title} variant="h3">
        {title}
      </Typography>
      <Box sx={classes.aside}>{children}</Box>
    </Box>
  );
}
